import {
  IUISceneController,
  TTranslateEditSceneParams,
  TTranslateEditSceneResult,
} from "../connector/UISceneController/types";
import React from "react";
import { Modal, Form, Input, Spin, Select } from "antd";
import { observer } from "mobx-react";
import { useScene } from "@view/hooks/useScene/useScene";
import { TranslationService } from "@services/translate";
import TextArea from "antd/lib/input/TextArea";

const TranslateEditForm = observer((): JSX.Element => {
  const UISceneController =
    useScene<
      IUISceneController<TTranslateEditSceneResult, TTranslateEditSceneParams>
    >();

  const [form] = Form.useForm();

  const handleSave = async () => {
    try {
      await form.validateFields();

      await UISceneController.saveTranslate();
    } catch (error) {
      console.info({ error });
    }
  };

  return (
    <Modal
      title={
        UISceneController.isEditing
          ? TranslationService.t("txt_update_entity", {
              entity: TranslationService.t("txt_translate"),
            })
          : TranslationService.t("txt_create_entity", {
              entity: TranslationService.t("txt_translate"),
            })
      }
      open
      onOk={handleSave}
      onCancel={() => UISceneController.closeScene()}
    >
      <Spin spinning={UISceneController.isRequestInProgress}>
        <Form
          form={form}
          layout="vertical"
          initialValues={UISceneController.translate}
          onFinish={console.info}
        >
          <Form.Item
            name={"key"}
            label={"Key"}
            initialValue={UISceneController.translate.key}
            rules={[
              {
                message: TranslationService.t("txt_field_is_required"),
                required: true,
              },
            ]}
          >
            <Input
              onChange={(event) =>
                UISceneController.translate.setKey(event.target.value)
              }
              value={UISceneController.translate.key}
            />
          </Form.Item>
          <Form.Item
            name={"Segment"}
            label={"Segment"}
            initialValue={UISceneController.translate.segment}
            rules={[
              {
                message: TranslationService.t("txt_field_is_required"),
                required: true,
              },
            ]}
          >
            <Select
              defaultValue={UISceneController.translate.segment}
              style={{ width: 120 }}
              onChange={(event) =>
                UISceneController.translate.setLibrary(event)
              }
              options={[
                {
                  label: "Api",
                  value: "api",
                },
                {
                  label: "Backend",
                  value: "messages",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            name={"en"}
            label={"En"}
            initialValue={UISceneController.translate.translations.en}
            rules={[
              {
                message: TranslationService.t("txt_field_is_required"),
                required: true,
              },
            ]}
          >
            <Input
              onChange={(event) =>
                UISceneController.translate.setTranslation(
                  "en",
                  event.target.value.toString()
                )
              }
              value={UISceneController.translate.translations.en}
            />
          </Form.Item>
          <Form.Item
            name={"ar"}
            label={"Ar"}
            initialValue={UISceneController.translate.translations.ar}
            rules={[
              {
                message: TranslationService.t("txt_field_is_required"),
                required: true,
              },
            ]}
          >
            <Input
              onChange={(event) =>
                UISceneController.translate.setTranslation(
                  "ar",
                  event.target.value
                )
              }
              value={UISceneController.translate.translations.ar}
            />
          </Form.Item>
          <Form.Item
            name={"context"}
            label={TranslationService.t(`txt_context`)}
            initialValue={UISceneController.translate.translations.en}
            rules={[
              {
                message: TranslationService.t("txt_field_is_required"),
                required: false,
              },
            ]}
          >
            <TextArea
              onChange={(event) =>
                UISceneController.translate.setContext(event.target.value)
              }
              value={UISceneController.translate.translations.en}
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});

export default TranslateEditForm;
